/* eslint-disable */
const getters = {
  getFilter(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
